export const GlobalConstant = {
  REACT_APP_BACKENDURL:
    process.env.REACT_APP_ENV.trim() === "production"
      ? "https://seattlevt.org/Backend/public/api"
      : "https://seattlevt.org/classflex_dev/Backend/public/api",
 
  GIBBON_URL:
    process.env.REACT_APP_ENV.trim() === "production"
      ? "https://seattlevt.org/HS/index.php"
      : "https://seattlevt.org/staging/index.php",
};

export const AllTimeZones = [
  "GMT-1200 (International Date Line West)",
  "GMT-1100 (Coordinated Universal Time)",
  "GMT-1000 (Hawaii Standard Time)",
  "GMT-0900 (Alaska Standard Time)",
  "GMT-0800 (Pacific Standard Time)",
  "GMT-0700 (Mountain Standard Time)",
  "GMT-0600 (Central Standard Time)",
  "GMT-0500 (Eastern Standard Time)",
  "GMT-0400 (Atlantic Standard Time)",
  "GMT-0300 (Argentina Standard Time)",
  "GMT-0200 (South Georgia Standard Time)",
  "GMT-0100 (Azores Standard Time)",
  "GMT+0000 (Coordinated Universal Time)",
  "GMT+0100 (Central European Time)",
  "GMT+0200 (Eastern European Time)",
  "GMT+0300 (Moscow Standard Time)",
  "GMT+0400 (Gulf Standard Time)",
  "GMT+0500 (Pakistan Standard Time)",
  "GMT+0600 (Bangladesh Standard Time)",
  "GMT+0700 (Indochina Time)",
  "GMT+0800 (China Standard Time)",
  "GMT+0900 (Japan Standard Time)",
  "GMT+1000 (Australian Eastern Standard Time)",
  "GMT+1100 (Solomon Islands Time)",
  "GMT+1200 (New Zealand Standard Time)",
];
